import(/* webpackMode: "eager" */ "/vercel/path0/fluxos-frontend/app/error.tsx");
